import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={9.315}
    height="6.8mm"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 2557 7056"
    {...props}
  >
    <defs>
      {/* <style>{".fil0{fill:#231f20}"}</style> */}
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974347723376">
        <path
          d="m257 4433 295-1c-4-322-33-3421 24-3608 218-707 1166-704 1393-28 71 211 37 906 37 1177 0 816 17 1648-2 2463l292-1c15-905 1-1822 1-2728 0-431 55-890-148-1224-384-634-1357-657-1745 8-205 353-147 777-147 1216 0 893 30 1840 0 2726z"
          className="fil0"
        />
        <path
          d="m590 6045 1374-5c-8-529-52-382 258-795 361-482 365-259 309-587-105-23-2423-29-2474-1-64 36-71 172-37 242 55 115 33-4 148 126l364 490c92 129 64 328 58 530z"
          style={{
            fill: "#221e1f",
          }}
          className="fill"
        />
        <path
          d="m830 4435 298-6-1-3284c0-205 17-287 234-266 126 205 69 565 69 828v2724l295 1c-27-723-6-2439-6-3099 1-339 29-542-210-690-247-154-524-25-624 169-120 236-49 3110-55 3623z"
          className="fil0"
        />
        <path
          d="M658 7017c102 62 1174 40 1227 1 79-75 63-222 26-320-136-59-1181-38-1218-23-117 49-86 262-35 342z"
          style={{
            // fill: "#242021",
          }}
          className="fill"
        />
        <path
          d="M664 6503c83 75 1140 70 1248 1 63-139 51-319-106-337l-1017-2c-293 5-145 317-125 338z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
